import { questoes } from '@/services/questoes'

export default {
	async getQuestionById (context, payload) {
		const res = context.state.list.find(i => i.id === payload)
		return res
	},
	async loadObjectQuestions (context, payload) {
		const res = await questoes.findById(payload.theme)
		let questao
		for (questao of res.data) {
			const valores = questao.valores.split('|~|')
			const corretas = questao.corretas.split('|~|')
			const datas = questao.datas.split('|~|')
			const alternativas = []

			for (var i = 0; i < corretas.length; i++) {
				alternativas.push({
					valor: valores[i],
					correta: corretas[i] === '1',
					dataCriacao: datas[i]
				})
			}

			questao.alternativas = alternativas
		}

		context.commit('LOAD_QUESTIONS', { data: res.data })
	},
	async unloadObjectQuestions (context, payload) {
		context.commit('UNLOAD_QUESTIONS', { data: [] })
	}
}
